import styled from 'styled-components';
import React from 'react';
import { FlexColAlignCenter } from '../primitives/flex';

const ArchivedInfoText = () => (
  <FlexColAlignCenter width="100%" margin="0 20px">
    <ArchivedHeading>No archived messages</ArchivedHeading>
    <ArchivedText>
      Archiving message threads removes it from your inbox and stores it here. It does not affect the booking status.
    </ArchivedText>
  </FlexColAlignCenter>
);

export default ArchivedInfoText;

const ArchivedHeading = styled.p`
  color: #17233c;
  font-size: 16px;
  line-height: 34px;
  font-weight: 600;
  text-align: center;
`;

const ArchivedText = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #17233c;
  text-align: center;
`;
